(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[71],{

/***/ "Adz/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vOnD");

var ButtonBox = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "ButtonBox",
  componentId: "u715n-0"
})(["position:relative;width:100%;display:flex;flex-direction:column;align-items:center;a{display:flex;justify-content:center;align-items:center;&:nth-child(2){margin-top:", "px;}}"], function (props) {
  return props.theme.baseline;
});
/* harmony default export */ __webpack_exports__["a"] = (ButtonBox);

/***/ }),

/***/ "Xs+j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./components/atoms/Button/index.js + 7 modules
var Button = __webpack_require__("8BE4");

// EXTERNAL MODULE: ./components/atoms/Link/index.tsx
var Link = __webpack_require__("ZT91");

// EXTERNAL MODULE: ./components/atoms/Text/index.js + 17 modules
var Text = __webpack_require__("wCgk");

// EXTERNAL MODULE: ./utils/generateClickableId.js
var generateClickableId = __webpack_require__("7dJx");

// EXTERNAL MODULE: ./utils/hooks/useCheckRegion.js
var useCheckRegion = __webpack_require__("h5Ls");

// EXTERNAL MODULE: ./components/pages/FrontPage/ButtonBox/index.js
var ButtonBox = __webpack_require__("Adz/");

// CONCATENATED MODULE: ./components/pages/FrontPage/Media/MediaIntro.js
var __jsx = react_default.a.createElement;










var MediaIntro_MediaIntro = function MediaIntro() {
  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isNO = _useCheckRegion.isNO;

  var href = isNO ? '/products/product?productHandle=soundboks-go' : '/products/?filter=speakers';
  var as = isNO ? '/products/soundboks-go' : '/products/?filter=speakers';
  return /*#__PURE__*/react_default.a.createElement(StyledMediaIntro, null, /*#__PURE__*/react_default.a.createElement(TextBlock, null, /*#__PURE__*/react_default.a.createElement(Text["d" /* H2 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "EXPERIENCE SOUNDBOKS"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Amazing people doing unbelievable things in incredible places."
  }))), /*#__PURE__*/react_default.a.createElement(ButtonWrapper, null, /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: href,
    as: as
  }, /*#__PURE__*/react_default.a.createElement(Button["e" /* StandardButton */], {
    fixedWidth: true,
    id: Object(generateClickableId["a" /* generateClickableId */])(1, 'Home', 'Media', 'Media')
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "MEDIA"
  })))));
};

var StyledMediaIntro = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MediaIntro__StyledMediaIntro",
  componentId: "yae4co-0"
})(["position:relative;display:flex;flex-direction:column;justify-content:center;width:100vw;@media ", "{width:", "px;justify-content:flex-end;margin-bottom:", "px;margin-right:", "px;}"], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.baseline * 31;
}, function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.halfBaseline * 5;
});
var TextBlock = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MediaIntro__TextBlock",
  componentId: "yae4co-1"
})(["margin-top:", "px;width:", "px;text-align:center;margin-left:auto;margin-right:auto;p{margin-bottom:0;}@media ", "{text-align:left;width:", "px;h2{margin-bottom:", "px;}}@media ", "{width:", "px;h2{margin-bottom:", "px;}}"], function (props) {
  return props.theme.baseline * 9;
}, function (props) {
  return props.theme.baseline * 26;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.baseline * 32;
}, function (props) {
  return props.theme.halfBaseline * 5;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.halfBaseline * 85;
}, function (props) {
  return props.theme.halfBaseline * 6;
});
var ButtonWrapper = Object(styled_components_browser_esm["default"])(ButtonBox["a" /* default */]).withConfig({
  displayName: "MediaIntro__ButtonWrapper",
  componentId: "yae4co-2"
})(["margin-top:", "px;a{margin-top:0;}@media ", "{align-items:flex-start;}@media ", "{margin-top:", "px;}"], function (props) {
  return props.theme.baseline * 3;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.halfBaseline * 7;
});
/* harmony default export */ var Media_MediaIntro = (MediaIntro_MediaIntro);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__("Vvt1");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: ./styles/theme.js
var theme = __webpack_require__("NVT0");

// CONCATENATED MODULE: ./components/pages/FrontPage/Media/MediaVideo.js
var MediaVideo_jsx = react_default.a.createElement;




var YoutubeVideo = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 23).then(__webpack_require__.bind(null, "gafT"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("gafT")];
    },
    modules: ['components/shared/YoutubeVideo']
  }
});

var MediaVideo_MediaVideo = function MediaVideo() {
  return /*#__PURE__*/react_default.a.createElement(Video, {
    videoId: "Eh_7ePS0egU"
  });
};

var Video = Object(styled_components_browser_esm["default"])(YoutubeVideo).withConfig({
  displayName: "MediaVideo__Video",
  componentId: "sc-4f8g2y-0"
})(["width:", "px;height:", "px;@media ", "{width:", "px;height:", "px;}@media ", "{width:", "px;height:", "px;}@media ", "{width:", "px;height:", "px;}"], theme["a" /* default */].baseline * 39, theme["a" /* default */].baseline * 23, theme["a" /* default */].breakpoints.tablet, theme["a" /* default */].baseline * 55, theme["a" /* default */].baseline * 33, theme["a" /* default */].breakpoints.desktop, theme["a" /* default */].baseline * 71, theme["a" /* default */].baseline * 42, theme["a" /* default */].breakpoints.desktopLarge, theme["a" /* default */].baseline * 115, theme["a" /* default */].baseline * 68);
/* harmony default export */ var Media_MediaVideo = (MediaVideo_MediaVideo);
// CONCATENATED MODULE: ./components/pages/FrontPage/Media/index.js
var Media_jsx = react_default.a.createElement;





var Media_MediaBlock = function MediaBlock() {
  return /*#__PURE__*/react_default.a.createElement(StyledMediaBlock, null, /*#__PURE__*/react_default.a.createElement(MediaVideoPositioner, null, /*#__PURE__*/react_default.a.createElement(Media_MediaVideo, null)), /*#__PURE__*/react_default.a.createElement(Media_MediaIntro, null));
};

var MediaVideoPositioner = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Media__MediaVideoPositioner",
  componentId: "sc-1qx04np-0"
})(["float:right;@media ", "{float:none;}"], function (props) {
  return props.theme.breakpoints.tablet;
});
var StyledMediaBlock = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Media__StyledMediaBlock",
  componentId: "sc-1qx04np-1"
})(["min-width:", "px;margin-top:-", "px;@media ", "{display:flex;flex-direction:row-reverse;margin-top:-", "px;margin-left:auto;margin-right:auto;max-width:", "px;}@media ", "{display:flex;flex-direction:row-reverse;margin-top:-", "px;margin-left:auto;margin-right:auto;max-width:", "px;justify-content:space-between;}@media only screen and (min-width:1200px){max-width:", "px;}@media only screen and (min-width:1600px){max-width:", "px;}@media ", "{max-width:", "px;}@media only screen and (min-width:2500px){max-width:", "px;}"], function (props) {
  return props.theme.baseline * 38;
}, function (props) {
  return props.theme.baseline * 7;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.halfBaseline * 5;
}, 768 - 40 - 40, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.halfBaseline * 15;
}, 1024 - 40 - 40, 1200 - 80 - 80, 1600 - 200 - 200, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, 1920 - 310 - 310, 2500 - 400 - 400);
/* harmony default export */ var Media = __webpack_exports__["default"] = (Media_MediaBlock);

/***/ })

}]);